import { jsx as _jsx } from "react/jsx-runtime";
import '../../shared/css/Section.css';
import '../../shared/css/generic-styles.css';
import '../../shared/css/Stack.css';
var Section = function (_a) {
    var className = _a.className, children = _a.children, style = _a.style, _b = _a.width, width = _b === void 0 ? 'fill' : _b, _c = _a.height, height = _c === void 0 ? 'hug' : _c;
    var sectionClasses = "section v-stack width-".concat(width, " height-").concat(height, " ").concat(className && "".concat(className), " ungroup");
    return (_jsx("div", { className: sectionClasses, style: style, children: children }));
};
export { Section };
